import React from "react";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import { isBeforeApril1st2024 } from "../../utils/createOrderCommonFunctions";

export default function DatePick({ handlePreferredDates, index, preferredDates }) {

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
        <DatePicker
          minDate={isBeforeApril1st2024() ? dayjs(new Date('2024-04-01T00:00:00.000')) : dayjs(new Date().setDate(new Date().getDate() + 2))}
          format='DD/MM/YYYY'
          value={(preferredDates) ? dayjs(preferredDates) : null}
          onChange={(date) => handlePreferredDates(index, new Date(date).toISOString())} 
          slotProps={{
            textField: {
              readOnly: true,
            },
          }}
          />
      </DemoContainer>
    </LocalizationProvider>
  );
}
